export class ApiError extends Error {
  constructor(status, detail) {
    super(detail || `Request failed (${status})`)
    this.status = status
    this.detail = detail
  }
}

async function throwApiError(response) {
  let detail = null
  try {
    detail = (await response.json()).detail
  } catch {
    // non-JSON error body; keep the status-based message
  }
  throw new ApiError(response.status, detail)
}

export async function api(path, { method = 'GET', body } = {}) {
  let response
  try {
    response = await fetch(path, {
      method,
      headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
      body: body !== undefined ? JSON.stringify(body) : undefined,
      credentials: 'same-origin',
    })
  } catch {
    throw new ApiError(0, 'Network error — check your connection and try again.')
  }
  if (response.status === 401 && !path.startsWith('/api/v1/auth/')) {
    // The session lapsed mid-visit. App.jsx listens and swaps the shell for
    // the signed-out card that fits the URL, so nothing renders blank. The
    // auth routes are excluded: /me answering 401 is a normal start.
    window.dispatchEvent(new CustomEvent(SIGNED_OUT_EVENT))
  }
  if (!response.ok) await throwApiError(response)
  if (response.status === 204) return null
  return response.json()
}

export const SIGNED_OUT_EVENT = 'capston:signed-out'

// Map a FastAPI 422 detail array to { fieldName: message } for field-adjacent
// errors. Returns null when the error isn't a validation error.
export function fieldErrorsFromDetail(detail) {
  if (!Array.isArray(detail)) return null
  const errors = {}
  for (const item of detail) {
    const field = Array.isArray(item.loc) ? item.loc[item.loc.length - 1] : null
    if (field) errors[field] = String(item.msg || 'Invalid value.').replace(/^Value error, /, '')
  }
  return Object.keys(errors).length > 0 ? errors : null
}
